const api = process.env.REACT_APP_API;

export const APIs = {
  AUTH: {
    SIGNUP: `${api}/user/signup`,
    SIGNIN: `${api}/user/signin`,
    EDIT_PROFILE: `${api}/user/update`,
    NOTIFICATION: `${api}/user/notifications`
  },
  TAILORING: {
    TRENDING_STYLES: `${api}/tailoring/trending`,
    STYLES_CATEGORIES: `${api}/admin/style/cats`,
    ALLSTYLES_BY_CATEGORY: `${api}/tailoring/similar`,
    ALLSTYLES_BY_GENDER: `${api}/tailoring/tailorings`,
    MAKE_TAILORING_ORDER: (id) => `${api}/tailoring/customize/checkout/${id}`,
    CUSTOM_CHECKOUT: (id) => `${api}/tailoring/custom/${id}/checkout`,
    ADD_TO_CART: `${api}/tailoring/customize/cart`,
    CART: `${api}/tailoring/cart/view`,
    MULTIPLE_CHECKOUT: `${api}/tailoring/cart/checkout`,
    ORDER_DETAILS: `${api}/user/order`,
    SIMILAR_STYLES: (cat) => `${api}/tailoring/similar?category=${cat}`,
  },
  LAUNDRY: {
    LAUNDRY_ORDER: `${api}/laundry/order/new`,
    LAUNDRY_CHECKOUT: (id) => `${api}/laundry/checkout?id=${id}&process=checkout`,
    LAUNDRY_TYPES: `${api}/laundry/types`
  },
  PAYMENT: {
    CONFIRM_PAYMENT: `${api}/payment/confirm`,
  },
};
